/* ToTheLove — Custom element <obfuscated-link>
 * Offuscation de liens : l'URL n'apparaît jamais en clair dans le HTML.
 * Elle est encodée en base64 dans [data-url] et décodée uniquement au clic
 * (ou Entrée/Espace au clavier) sur le premier enfant (<span role="link">).
 *
 * - data-target="_blank" sur le wrapper → ouverture nouvel onglet (liens externes).
 *   Par défaut : même onglet. noopener,noreferrer systématique.
 * - Défini une seule fois (garde customElements.get), chargé en defer depuis
 *   sections/footer.liquid (le footer est présent sur toutes les pages).
 *   Si on offusque ailleurs un jour (header, panier), déplacer le chargement
 *   dans layout/theme.liquid.
 */
if (!customElements.get('obfuscated-link'))
  customElements.define(
    'obfuscated-link',
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        const { signal } = (this.controller = new AbortController());

        this.element ??= this.querySelector(':scope > *');

        if (!this.element) return console.warn('<obfuscated-link>: children needed', this);
        if (!this.dataset.url) return console.warn('<obfuscated-link>: [data-url] attribute required', this);

        this.element.addEventListener('click', this.onClickHandler.bind(this), { signal });
        this.element.addEventListener('keydown', this.onKeyDownHandler.bind(this), { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      onClickHandler() {
        this.open();
      }

      onKeyDownHandler(event) {
        switch (event.key) {
          case 'Enter':
          case ' ':
            event.preventDefault();
            this.open();
            break;
        }
      }

      open() {
        const target = this.getAttribute('data-target') || '_self';
        window.open(this.decode, target, 'noopener,noreferrer');
      }

      get decode() {
        const bytes = Uint8Array.from(window.atob(this.getAttribute('data-url')), (c) => c.charCodeAt(0));
        return new TextDecoder().decode(bytes);
      }
    }
  );
